import React, { useState } from "react";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Toast,
  ToastBody,
  ToastHeader,
  UncontrolledTooltip,
} from "reactstrap";
import { toast } from "react-toastify";

import {
  Container,
  Row,
  Button,
  Col,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
} from "reactstrap";
import { Field, Formik } from "formik";
import FormikDatePicker from "components/common/Fields/FormikDatePicker";
import moment from "moment";

// import { Field, Formik } from 'formik';
import HoverImage from "react-hover-image/build";
import { cellRendererCheck, dateFormate } from "utils/columns";
import filter from "assets/icon/filter-icon.svg";
import SortArrow from "assets/icon/sort-arrow.svg";
import Plus from "assets/icon/plus-rx.svg";
import Calendar from "assets/icon/calendar-pms.svg";
import admin from "assets/icon/admin-black.svg";
import Cal from "assets/icon/calendar-pms.svg";
import ArrowRight from "assets/icon/arrow-right-purple.svg";
import ScanIcon from "assets/icon/scan-icon.svg";
import drug from "assets/icon/drug-status.svg";
import drugList from "assets/icon/drug-list.svg";
import threeDotsIcon from "assets/icon/3-dots.svg";
import closeIcon from "assets/icon/close-icon.svg";
import { useNavigate } from "react-router-dom";
import DrugUtilPopUp from "pages/OrderEntry/DrugUtilPopUp";
import Drawer from "components/Drawer";
import ClaimsInfo from "pages/OrderEntry/ClaimsInfo";
import plusIcon from "assets/icon/plus-icon-add-note.svg";
import uploadIcon from "assets/icon/upload-icon.svg";
import drugPurpleIcon from "assets/icon/drug-status.svg";
import drugLightIcon from "assets/icon/drug-with-reddot.svg";
import drugWhite from "assets/icon/druglist-green.svg";
import searchIcon from "assets/icon/search.svg";
import patientsScanImage from "assets/images/patients-scan.svg";
// import plusIcon from 'assets/icon/plus-icon-add-note.svg'
import ZoomInIcon from "assets/icon/zoom-in-icon.svg";
import ZoomOutIcon from "assets/icon/zoom-out-icon.svg";
import DeleteIcon from "assets/icon/delete-icon.svg";
import PatientsDemographic from "components/PatientsDemographic";
import FormikSelectField from "components/common/Fields/FormikSelectField";
import SearchContainer from "pages/OrderEntry/SearchContainer/Index";
import DatePicker from "react-datepicker";
import ReactInputMask from "react-input-mask";
import Confirm from "components/Confirm";
import addIcon from "assets/icon/add-icon.svg";
import cancelIcon from "assets/icon/cancel-icon.svg";
import SearchContainerOrderEntry from "components/SearchContainerOrderEntry";
import MessageIconDark from "assets/icon/messageIcon-dark.svg";
import MessageIconLight from "assets/icon/messageIcon-light.svg";

import completeIcon from "assets/icon/complete.svg";
import orderDetailsIcon from "assets/icon/order-details-icon.svg";
import leftArrow from "assets/icon/left-arrow.svg";
import Chating from "pages/OrderEntry/Chating";
import searchGrayIcon from "assets/icon/search-inactive.svg";
import plusPurple from "../../../../assets/icon/plus-icon-add-note.svg";
import plusIcons from "../../../../assets/icon/plus-icon.svg";
import dubbleArrow from "../../../../assets/icon/double-arrow-down-purple.svg";
import eidtPurpleIcon from "../../../../assets/icon/eidtPurpleIcon.svg";
import deleteIcon from "../../../../assets/icon/delete-white-icon.svg";
import upArrow from "../../../../assets/inventory/up-arrow.svg";
import downArrow from "../../../../assets/inventory/down-arrow.svg";
import saveIcon from "../../../../assets/icon/save-btn-icon.svg";
import submitIcon from "../../../../assets/icon/submit-btn-icon.svg";
import resetIcon from "../../../../assets/icon/reset-btn-icon.svg";

const AddNewPatient = () => {
  const navigate = useNavigate();
  const [name, setName] = useState();
  const [lastName, setLastName] = useState();
  const [focusedInput, setFocusedInput] = useState("");
  const [open, setOpen] = useState("1");
  const [searchTerm, setSearchTerm] = useState("");
  const [scale, setScale] = useState(1);
  const [isImageVisible, setIsImageVisible] = useState(true);
  const initialImage = patientsScanImage;
  const [image, setImage] = useState(initialImage);
  const [endDate, setEndDate] = useState();
  const [startDate, setStartdate] = useState();
  const [confirm, setConfirm] = useState(false);
  const [drugUtil, setDrugUtil] = useState(false);
  const [claimsInfo, setClaimsInfo] = useState(false);
  const [msgInfo, setMsgInfo] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [quantity, setQuantity] = useState("30");
  const [daySupply, setDaySupply] = useState("30");
  const [refills, setRefills] = useState("5");
  const [directions, setDirections] = useState("Take 1 Tablet By Mouth Daily");
  const [openOne, setOpenOne] = useState("1");
  const [openTwo, setOpenTwo] = useState("1");
  const [openThree, setOpenThree] = useState("1");

  const [searchTermPrescriber, setSearchTermPrescriber] = useState({
    medication: "Venlafaxine ER Tablet 150MG",
    prescriber: "ROBERT SMITH, MD",
    dignosis: "",
  });
  const [tasks, setTasks] = useState([]);
  const [newTask, setNewTask] = useState("");
  const [activeNewTask, setActiveNewTask] = useState("");

  const [selectedOptions, setSelectedOptions] = useState({
    option1: "",
    option2: "",
  });
  const [increment, setIncrement] = useState({
    totalQtyWritten: "",
    serialNo: 0,
    partialFillQty: "",
  });
  const [data, setData] = useState({
    one: "",
  });

  const togglebtnOne = (id) => {
    if (openOne === id) {
      setOpenOne();
    } else {
      setOpenOne(id);
    }
  };

  const togglebtnTwo = (id) => {
    if (openTwo === id) {
      setOpenTwo();
    } else {
      setOpenTwo(id);
    }
  };

  const handleActiveTask = () => {
    if (activeNewTask.trim() === "") return;
    setActiveNewTask([
      ...activeNewTask,
      { activeTask: activeNewTask, completed: false },
    ]);
  };

  const togglebtnThree = (id) => {
    if (openThree === id) {
      setOpenThree();
    } else {
      setOpenThree(id);
    }
  };

  const handleChangeDirections = (e) => {
    setDirections(e.target.value);
  };
  const [isTooltipEnabled, setIsTooltipEnabled] = useState(true);
  const [todosOne, setTodosOne] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const namesData = {
    fullName: "Doe, John",
    firstName: "John",
    lastName: "Doe",
    phone: "(555) 123-4567",
    dob: "01/08/1996 (28 Years)",
  };

  const handleSubmitOption = (event) => {
    event.preventDefault();
    console.log("Selected option:", selectedOption);
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      setIsButtonEnabled(true);
    }
  };
  const handleChangeOption = (e) => {
    const { name, value } = e.target;
    setSelectedOptions((prevOptions) => ({
      ...prevOptions,
      [name]: value,
    }));
  };
  // Clear individual fields
  const clearSearch = (field) => {
    setSearchTermPrescriber((prev) => ({
      ...prev,
      [field]: "",
    }));
  };

  const handleInputChangePrescriber = (e) => {
    const { name, value } = e.target;
    setSearchTermPrescriber((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const clearSearchPrescriber = () => {
    setSearchTermDrug("");
  };
  const handleChangeIncrement = (e) => {
    const { name, value } = e.target;
    setIncrement((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleIncrement = () => {
    setIncrement((prevState) => ({
      ...prevState,
      totalQtyWritten: prevState.totalQtyWritten + 1,
    }));
  };
  const handleDecrement = () => {
    if (increment.totalQtyWritten > 0) {
      setIncrement((prevState) => ({
        ...prevState,
        totalQtyWritten: prevState.totalQtyWritten - 1,
      }));
    }
  };
  const handleAddTask = () => {
    if (newTask.trim() === "") return;
    setTasks([...tasks, { task: newTask, completed: false }]);
    setNewTask("");
  };

  const toggleTaskCompletion = (index) => {
    const updatedTasks = [...tasks];
    updatedTasks[index].completed = !updatedTasks[index].completed;
    setTasks(updatedTasks);
  };

  const handleDeleteTask = (index) => {
    const updatedTasks = tasks.filter((_, idx) => idx !== index);
    setTasks(updatedTasks);
  };
  const togglebtn = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };
  const goBack = () => {
    navigate(-1);
    // setConfirm(true);
  };

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  let hasDatePopupOpen = false;
  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };
  const handleBlur = () => {
    setFocusedInput("");
  };
  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const handleFocus = (inputName) => {
      setFocusedInput(inputName);
    };
    // const handlesave = () => {
    //     handleSaveConfirmation();
    // }
    const onLeave = () => {
      handleSaveConfirmation();
    };
    const handleSaveConfirmation = () => {
      setConfirm(!confirm);
    };
  };

  const handleStartDate = (startDate) => {
    if (startDate !== null) {
      const date = moment(startDate, "MM/DD/YYYY", true);
      if (date.isValid()) {
        setStartdate(date.toDate());
        // SearchTerms.startDate=startDate
      }
    } else {
      setStartdate(null);
      // SearchTerms.startDate=null
    }
  };
  const handleStartDateRaw = (e) => {
    var val = e.target.value;
    if (val == "__/__/____" && startDate !== null) {
      setStartdate(null);
      // setError(false);
      //SearchTerms.startDate = null;
    }
    if (val !== undefined && val.length == 10 && val.indexOf("_") == -1) {
      handleStartDate(e.target.value);
      //SearchTerms.startDate = val;
    }
  };
  const handleEndDate = (startDate) => {
    if (startDate !== null) {
      const date = moment(startDate, "MM/DD/YYYY", true);
      if (date.isValid()) {
        setEndDate(date.toDate());
        // SearchTerms.startDate=startDate
      }
    } else {
      setEndDate(null);
      // SearchTerms.startDate=null
    }
  };
  const handleEndDateRaw = (e) => {
    var val = e.target.value;
    if (val == "__/__/____" && startDate !== null) {
      setEnddate(null);
      setError(false);
      //SearchTerms.startDate = null;
    }
    if (val !== undefined && val.length == 10 && val.indexOf("_") == -1) {
      handleEndDate(e.target.value);
      //SearchTerms.startDate = val;
    }
  };
  const handleFocus = (inputName) => {
    setFocusedInput(inputName);
  };
  // const handlesave = () => {
  //     handleSaveConfirmation();
  // }
  const onLeave = () => {
    handleSaveConfirmation();
  };
  const handleSaveConfirmation = () => {
    setConfirm(!confirm);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const handleSubmit = (field) => {
    const newEntry = { id: Date.now(), value: data[field] };
    if (data.one !== "") {
      setTodosOne([...todosOne, newEntry]);
    }
    setData({ ...data, [field]: "" });
  };

  const onsubmit = () => {
    toast.success("E-Prescription has successfully approved");
  };
  const handleZoomIn = () => {
    setScale((prevScale) => prevScale + 0.2); // Increase the scale by 0.2
  };
  const handleZoomOut = () => {
    setScale((prevScale) => Math.max(prevScale - 0.2, 0.5)); // Decrease the scale, minimum scale is 0.5
  };
  const handleDelete = (e) => {
    setIsImageVisible(true);
  };
  return (
    <>
      <Container fluid className="bg-white p-3 details-page-body pb-2">
        <Container fluid>
          <Container
            fluid
            className="d-flex gap-2 orderEntry-heading section-devider-border pb-2 mb-2"
          >
            <img src={leftArrow} onClick={goBack} className="cursor-pointer left-arrow-btn"/>
            <div className="heading-text">Create New Rx</div>
          </Container>
          <Container fluid>
            <SearchContainerOrderEntry />
          </Container>
          <Container fluid>
            <PatientsDemographic
              fullName={namesData.fullName}
              firstName={namesData.firstName}
              lastName={namesData.lastName}
              dob={namesData.dob}
              phone={namesData.phone}
            />
          </Container>
          <Container fluid className="logo-drawer">
            <Row>
              <Col className="d-flex justify-content-start gap-2">
                <div
                  onClick={!isImageVisible ? () => setDrugUtil(true) : null}
                  id="ScheduleUpdateTooltip"
                  style={{ opacity: isImageVisible ? "0.4" : "" }}
                >
                  <HoverImage
                    className="drug-status"
                    src={drugPurpleIcon}
                    hoverSrc={drugLightIcon}
                    alt=""
                  />
                  <UncontrolledTooltip
                    placement="bottom"
                    target="ScheduleUpdateTooltip"
                    trigger="hover"
                  >
                    Drug Utilization Review
                  </UncontrolledTooltip>
                </div>
                <div
                  onClick={!isImageVisible ? () => setClaimsInfo(true) : null}
                  style={{ opacity: isImageVisible ? "0.4" : "" }}
                  id="ScheduleUpdateTooltip2"
                >
                  <HoverImage
                    className="drug-status disabled"
                    src={drugList}
                    hoverSrc={drugWhite}
                    alt=""
                  />
                  <UncontrolledTooltip
                    // className="tooltip-custom"
                    style={{ position: "relative", left: "30px" }}
                    placement="bottom"
                    target="ScheduleUpdateTooltip2"
                    trigger="hover"
                  >
                    Claims Information
                  </UncontrolledTooltip>
                </div>
                <div
                  // className="drug-status"
                  onClick={() => setMsgInfo(!msgInfo)}
                  // style={{ opacity: !msgInfo ? "0.4" : "" }}
                  id="ScheduleUpdateTooltip3"
                >
                  <HoverImage
                    src={MessageIconDark}
                    className="drug-status "
                    hoverSrc={MessageIconLight}
                    alt=""
                  />
                  <UncontrolledTooltip
                    // className="tooltip-custom"
                    style={{ position: "relative", left: "30px" }}
                    placement="bottom"
                    target="ScheduleUpdateTooltip3"
                    trigger="hover"
                  >
                    Comments
                  </UncontrolledTooltip>
                </div>
                <div
                  className="comment"
                  style={{ opacity: isImageVisible ? "0.4" : "" }}
                >
                  <img src={completeIcon} alt="not available" />
                  340B Eligible
                </div>
              </Col>
              <Col className="d-flex justify-content-end gap-2">
                <Button
                  color="primary"
                  className="reset"
                  disabled={!isButtonEnabled}
                  style={{ opacity: isImageVisible ? "0.4" : "" }}
                >
                  Patient Profile
                </Button>
                <Button
                  className="back-button primary "
                  disabled={!isButtonEnabled}
                  style={{ opacity: isImageVisible ? "0.4" : "" }}
                >
                  Rx History
                </Button>
                <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                  <DropdownToggle color="primary" className="togglebtn ">
                    {dropdownOpen ? (
                      <img src={closeIcon} alt="icon" />
                    ) : (
                      <img src={threeDotsIcon} alt="icon" />
                    )}
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem className="dropdownitem-border">
                      <img src={plusIcon} /> Add Notes
                    </DropdownItem>
                    <DropdownItem className="dropdownitem-border">
                      {" "}
                      <img src={uploadIcon} /> Print
                    </DropdownItem>
                    <DropdownItem className="dropdownitem-border">
                      {" "}
                      <img src={uploadIcon} /> E-Rx Details{" "}
                    </DropdownItem>
                    <DropdownItem className="dropdownitem-border">
                      {" "}
                      <img src={uploadIcon} /> Forward Rx
                    </DropdownItem>
                    <DropdownItem className="dropdownitem-border">
                      {" "}
                      <img src={uploadIcon} /> Due
                    </DropdownItem>
                    <DropdownItem className="dropdownitem-border">
                      {" "}
                      <img src={uploadIcon} /> P/A
                    </DropdownItem>
                    <DropdownItem className="dropdownitem-border">
                      {" "}
                      <img src={uploadIcon} /> Rx History
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </Col>
            </Row>
          </Container>
          <Formik
            // initialValues={searchTerms}
            // onSubmit={handleSubmit}
            // onReset={handleReset}
            // validationSchema={validationSchema}
            enableReinitialize={true}
            children={(props) => {
              const {
                isSubmitting,
                // handleSubmit,
                resetForm,
                setFieldValue,
                errors,
                touched,
              } = props;
              return (
                <>
                  <div>
                    <Row className="fixedHeight">
                      <div className="rx-accordian-div">
                        <Accordion open={openOne} toggle={togglebtnOne}>
                          <AccordionItem>
                            <AccordionHeader targetId="1">
                              Order Details
                              <span className="order-details">
                                <img src={orderDetailsIcon} /> - $5.70
                              </span>
                            </AccordionHeader>
                            <AccordionBody accordionId="1">
                              <Row>
                                <Col md={6}>
                                  <div
                                    className="d-flex justify-content-center gap-2 p-box bg-light "
                                    style={{ borderRadius: "4px" }}
                                  >
                                    <div>
                                      {scale ? (
                                        <div className="parent-scan">
                                          {isImageVisible ? (
                                            <div
                                              className="scan-col d-flex justify-content-center align-items-center"
                                              style={{ width: "380px" }}
                                            >
                                              <Button
                                                color="dark"
                                                className="primary dark"
                                                onClick={() => {
                                                  setIsImageVisible(false);
                                                  setIsButtonEnabled(true);
                                                }}
                                              >
                                                Scan Rx
                                                <img src={ScanIcon} />
                                              </Button>
                                            </div>
                                          ) : (
                                            <div className="d-flex">
                                              <div>
                                                <img
                                                  src={patientsScanImage} // Replace with your image URL
                                                  alt="Zoomable"
                                                  style={{
                                                    transform: `scale(${scale})`,
                                                    transition:
                                                      "transform 0.3s ease",
                                                    maxWidth: "100%",
                                                    display: "block",
                                                    height: "auto",
                                                    padding: "10px",
                                                  }}
                                                />
                                              </div>
                                              <div>
                                                <div>
                                                  <img
                                                    src={ZoomInIcon}
                                                    onClick={handleZoomIn}
                                                  />
                                                </div>
                                                <div>
                                                  <img
                                                    src={ZoomOutIcon}
                                                    onClick={handleZoomOut}
                                                  />
                                                </div>
                                                <div>
                                                  <img
                                                    src={DeleteIcon}
                                                    onClick={handleDelete}
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </div>
                                </Col>
                                {isButtonEnabled ? (
                                  <Col md={6}>
                                    <h2 className="heading-pres">
                                      Order Entry{" "}
                                    </h2>
                                    <div
                                      style={{
                                        borderTop: "1px solid #D3D3D3",
                                        // padding: "8px",
                                      }}
                                    >
                                      <Row>
                                        <Col
                                          sm={12}
                                          md={6}
                                          className="required-date "
                                        >
                                          <Label className="order-entry-details">
                                            Date Written
                                          </Label>
                                          <InputGroup
                                            onMouseLeave={handleMouseLeave}
                                            className="date-14px"
                                          >
                                            <DatePicker
                                              id="startDate"
                                              name="startDate"
                                              selected={startDate}
                                              onChange={(startDate) =>
                                                handleStartDate(startDate)
                                              }
                                              onFocus={() =>
                                                handleFocus("StartDate")
                                              }
                                              onBlur={handleBlur}
                                              isClearable
                                              onChangeRaw={handleStartDateRaw}
                                              dateFormat="MM/dd/yyyy"
                                              placeholderText="MM/DD/YYYY"
                                              autoComplete="off"
                                              customInput={
                                                <ReactInputMask
                                                  mask="99/99/9999"
                                                  value={startDate}
                                                />
                                              }
                                            />
                                            <InputGroupText
                                              onClick={() =>
                                                handleDateClick("startDate")
                                              }
                                            >
                                              <img src={Calendar} alt="" />
                                            </InputGroupText>
                                          </InputGroup>
                                        </Col>
                                        <Col
                                          sm={12}
                                          md={6}
                                          className="required-date "
                                        >
                                          <Label className="order-entry-details">
                                            Dispense Date
                                          </Label>
                                          <InputGroup
                                            onMouseLeave={handleMouseLeave}
                                            className="date-14px"
                                          >
                                            <DatePicker
                                              id="endDate"
                                              name="endDate"
                                              selected={endDate}
                                              onChange={(endDate) =>
                                                handleEndDate(endDate)
                                              }
                                              onFocus={() =>
                                                handleFocus("endDate")
                                              }
                                              onBlur={handleBlur}
                                              isClearable
                                              onChangeRaw={handleEndDateRaw}
                                              dateFormat="MM/dd/yyyy"
                                              placeholderText="MM/DD/YYYY"
                                              autoComplete="off"
                                              customInput={
                                                <ReactInputMask
                                                  mask="99/99/9999"
                                                  value={endDate}
                                                />
                                              }
                                            />
                                            <InputGroupText
                                              onClick={() =>
                                                handleDateClick("endDate")
                                              }
                                            >
                                              <img src={Calendar} alt="" />
                                            </InputGroupText>
                                          </InputGroup>
                                        </Col>
                                      </Row>
                                      <Row>
                                        <FormGroup className="controls textarea_info search-flex mb-0">
                                          <Label className="order-entry-details">
                                            Medication
                                          </Label>
                                          <InputGroup>
                                            <Input
                                              // className="required"
                                              type="text"
                                              name="medication"
                                              value={
                                                searchTermPrescriber.medication
                                              }
                                              onChange={
                                                handleInputChangePrescriber
                                              }
                                              placeholder="Search by Product Name"
                                            />
                                            {searchTermPrescriber.medication ? (
                                              <button
                                                onClick={() =>
                                                  clearSearch("medication")
                                                }
                                                className="clearButton"
                                              >
                                                &#x2715;{" "}
                                                {/* Unicode for the "x" symbol */}
                                              </button>
                                            ) : (
                                              <img src={searchGrayIcon} />
                                            )}
                                          </InputGroup>
                                        </FormGroup>
                                      </Row>
                                      <Row>
                                        <FormGroup className="controls textarea_info search-flex mb-0">
                                          <Label className="order-entry-details">
                                            Prescriber
                                          </Label>
                                          <InputGroup>
                                            <Input
                                              // className="required"
                                              type="text"
                                              name="prescriber"
                                              value={
                                                searchTermPrescriber.prescriber
                                              }
                                              onChange={
                                                handleInputChangePrescriber
                                              }
                                              placeholder="Search by Prescriber name "
                                            />
                                            {searchTermPrescriber.prescriber ? (
                                              <button
                                                onClick={() =>
                                                  clearSearch("prescriber")
                                                }
                                                className="clearButton"
                                              >
                                                &#x2715;{" "}
                                                {/* Unicode for the "x" symbol */}
                                              </button>
                                            ) : (
                                              <img src={searchGrayIcon} />
                                            )}
                                          </InputGroup>
                                        </FormGroup>
                                      </Row>
                                      <Row>
                                        <FormGroup className="controls mb-0">
                                          <Label className="order-entry-details">
                                            Directions
                                          </Label>
                                          <Input
                                            style={{ border: "1px soild" }}
                                            className="textlength"
                                            name="directions"
                                            type="textarea"
                                            value={directions}
                                            onChange={handleChangeDirections}
                                            placeholder="Enter Directions"
                                          />
                                        </FormGroup>
                                      </Row>
                                      <Row>
                                        <Col sm={12} md={4}>
                                          <FormGroup className="controls textarea_info search-flex mb-0 ">
                                            <Label className="order-entry-details">
                                              Quantity
                                            </Label>
                                            <InputGroup>
                                              <Input
                                                setcss="required"
                                                type="number"
                                                value={quantity}
                                                onChange={(e) =>
                                                  setQuantity(e.target.value)
                                                }
                                                autoComplete="off"
                                                placeholder="30"
                                              />
                                            </InputGroup>
                                          </FormGroup>
                                        </Col>
                                        <Col sm={12} md={4}>
                                          <FormGroup className="controls textarea_info search-flex mb-0">
                                            <Label className="order-entry-details">
                                              Day Supply
                                            </Label>
                                            <InputGroup>
                                              <Input
                                                setcss="required"
                                                type="number"
                                                autoComplete="off"
                                                placeholder="5"
                                                value={daySupply}
                                                onChange={(e) =>
                                                  setDaySupply(e.target.value)
                                                }
                                              />
                                            </InputGroup>
                                          </FormGroup>
                                        </Col>
                                        <Col sm={12} md={4}>
                                          <FormGroup className="controls textarea_info search-flex mb-0">
                                            <Label className="order-entry-details">
                                              Refill
                                            </Label>
                                            <InputGroup>
                                              <Input
                                                setcss="required"
                                                type="number"
                                                autoComplete="off"
                                                placeholder="0"
                                                value={refills}
                                                onChange={(e) =>
                                                  setRefills(e.target.value)
                                                }
                                              />
                                            </InputGroup>
                                          </FormGroup>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>
                                ) : (
                                  <Col md={6}>
                                    <h2 className="heading-pres">
                                      Order Entry{" "}
                                    </h2>
                                    <div
                                      style={{
                                        borderTop: "1px solid #D3D3D3",
                                        // padding: "8px",
                                      }}
                                    >
                                      <Row>
                                        <Col
                                          sm={12}
                                          md={6}
                                          className="required-date "
                                        >
                                          <Label className="order-entry-details">
                                            Date Written
                                          </Label>
                                          <InputGroup
                                            onMouseLeave={handleMouseLeave}
                                          >
                                            <DatePicker
                                              id="startDate"
                                              name="startDate"
                                              // selected={startDate}
                                              onChange={(startDate) =>
                                                handleStartDate(startDate)
                                              }
                                              onFocus={() =>
                                                handleFocus("StartDate")
                                              }
                                              onBlur={handleBlur}
                                              isClearable
                                              onChangeRaw={handleStartDateRaw}
                                              dateFormat="MM/dd/yyyy"
                                              placeholderText="Select a date"
                                              autoComplete="off"
                                              customInput={
                                                <ReactInputMask mask="99/99/9999" />
                                              }
                                            />
                                            <InputGroupText
                                              onClick={() =>
                                                handleDateClick("startDate")
                                              }
                                            >
                                              <img src={Calendar} alt="" />
                                            </InputGroupText>
                                          </InputGroup>
                                        </Col>
                                        <Col
                                          sm={12}
                                          md={6}
                                          className="required-date "
                                        >
                                          <Label className="order-entry-details">
                                            Dispense Date
                                          </Label>
                                          <InputGroup
                                            onMouseLeave={handleMouseLeave}
                                          >
                                            <DatePicker
                                              id="endDate"
                                              name="endDate"
                                              // selected={endDate}
                                              onChange={(endDate) =>
                                                handleEndDate(endDate)
                                              }
                                              onFocus={() =>
                                                handleFocus("endDate")
                                              }
                                              onBlur={handleBlur}
                                              isClearable
                                              onChangeRaw={handleEndDateRaw}
                                              dateFormat="MM/dd/yyyy"
                                              placeholderText="Select a date"
                                              autoComplete="off"
                                              customInput={
                                                <ReactInputMask mask="99/99/9999" />
                                              }
                                            />
                                            <InputGroupText
                                              onClick={() =>
                                                handleDateClick("endDate")
                                              }
                                            >
                                              <img src={Calendar} alt="" />
                                            </InputGroupText>
                                          </InputGroup>
                                        </Col>
                                      </Row>
                                      <Row>
                                        <FormGroup className="controls textarea_info search-flex mb-0">
                                          <Label className="order-entry-details">
                                            Medication
                                          </Label>
                                          <InputGroup>
                                            <Input
                                              // className="required"
                                              type="text"
                                              name="medication"
                                              // value={
                                              //   searchTermPrescriber.medication
                                              // }
                                              onChange={
                                                handleInputChangePrescriber
                                              }
                                              placeholder="Search by Medication name"
                                            />
                                            {searchTermPrescriber.medication ? (
                                              <button
                                                onClick={() =>
                                                  clearSearch("medication")
                                                }
                                                className="clearButton"
                                              >
                                                &#x2715;{" "}
                                                {/* Unicode for the "x" symbol */}
                                              </button>
                                            ) : (
                                              <img src={searchGrayIcon} />
                                            )}
                                          </InputGroup>
                                        </FormGroup>
                                      </Row>
                                      <Row>
                                        <FormGroup className="controls textarea_info search-flex mb-0">
                                          <Label className="order-entry-details">
                                            Prescriber
                                          </Label>
                                          <InputGroup>
                                            <Input
                                              // className="required"
                                              type="text"
                                              name="prescriber"
                                              // value={
                                              //   searchTermPrescriber.prescriber
                                              // }
                                              onChange={
                                                handleInputChangePrescriber
                                              }
                                              placeholder="Search by Prescriber name"
                                            />
                                            {searchTermPrescriber.prescriber ? (
                                              <button
                                                onClick={() =>
                                                  clearSearch("prescriber")
                                                }
                                                className="clearButton"
                                              >
                                                &#x2715;{" "}
                                                {/* Unicode for the "x" symbol */}
                                              </button>
                                            ) : (
                                              <img src={searchGrayIcon} />
                                            )}
                                          </InputGroup>
                                        </FormGroup>
                                      </Row>
                                      <Row>
                                        <FormGroup className="controls mb-0">
                                          <Label className="order-entry-details">
                                            Directions
                                          </Label>
                                          <Input
                                            style={{ border: "1px soild" }}
                                            className="textlength"
                                            type="textarea"
                                            placeholder="Enter Directions"
                                          />
                                        </FormGroup>
                                      </Row>
                                      <Row>
                                        <Col sm={12} md={4}>
                                          <FormGroup className="controls textarea_info search-flex mb-0 ">
                                            <Label className="order-entry-details">
                                              Quantity
                                            </Label>
                                            <InputGroup>
                                              <Input
                                                setcss="required"
                                                type="number"
                                                autoComplete="off"
                                                placeholder="30"
                                              />
                                            </InputGroup>
                                          </FormGroup>
                                        </Col>
                                        <Col sm={12} md={4}>
                                          <FormGroup className="controls textarea_info search-flex mb-0">
                                            <Label className="order-entry-details">
                                              Refills
                                            </Label>
                                            <InputGroup>
                                              <Input
                                                setcss="required"
                                                type="number"
                                                autoComplete="off"
                                                placeholder="5"
                                              />
                                            </InputGroup>
                                          </FormGroup>
                                        </Col>
                                        <Col sm={12} md={4}>
                                          <FormGroup className="controls textarea_info search-flex mb-0">
                                            <Label className="order-entry-details">
                                              DAW
                                            </Label>
                                            <InputGroup>
                                              <Input
                                                setcss="required"
                                                type="number"
                                                autoComplete="off"
                                                placeholder="0"
                                              />
                                            </InputGroup>
                                          </FormGroup>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>
                                )}
                              </Row>
                            </AccordionBody>
                          </AccordionItem>
                        </Accordion>
                        <Formik>
                          <Accordion
                            open={openTwo}
                            toggle={togglebtnTwo}
                            className="mt-1"
                          >
                            <AccordionItem>
                              <AccordionHeader targetId="1">
                                Payment / Insurance
                              </AccordionHeader>
                              <AccordionBody accordionId="1">
                                <Row>
                                  <Col>
                                    <h2 className="heading-pres">
                                      Add Insurance
                                    </h2>
                                    <div
                                      className="bg-light p-8 "
                                      style={{ borderTop: "1px solid #D3D3D3" }}
                                    >
                                      <FormGroup>
                                        <InputGroup>
                                          <Input
                                            type="text"
                                            value={newTask}
                                            onChange={(e) =>
                                              setNewTask(e.target.value)
                                            }
                                            placeholder="Search by Payer, BIN or PCN"
                                            className="bg-light"
                                          />
                                          <div
                                            onClick={handleAddTask}
                                            className="add-new-plan"
                                          >
                                            <img src={plusPurple} alt="" />
                                            <span>Add New Plan</span>
                                          </div>
                                        </InputGroup>
                                      </FormGroup>
                                      <div className="d-flex justify-content-between align-items-center gap-2 mb-2">
                                        <div className="plan-card">
                                          Novartis Discount Card
                                        </div>
                                        <Button
                                          onClick={handleActiveTask}
                                          color="primary"
                                          className="submit"
                                          // onClick={() => handleDeleteTask(index)}
                                          style={{ width: "20%" }}
                                        >
                                          <img src={plusIcons} /> Add
                                        </Button>
                                        {/* <Button color="" className=""></Button> */}
                                      </div>
                                      <div className="d-flex justify-content-between align-items-center gap-2  mb-2">
                                        <div className="plan-card">
                                          Apply Sliding Scale
                                        </div>
                                        <Button
                                          color="primary"
                                          className="submit"
                                          // onClick={() => handleDeleteTask(index)}
                                          style={{ width: "20%" }}
                                        >
                                          <img src={plusIcons} /> Add
                                        </Button>
                                        {/* <Button color="" className=""></Button> */}
                                      </div>
                                      <div className="d-flex justify-content-between align-items-center gap-2 mb-2">
                                        <div className="plan-card">
                                          340B Cash Card
                                        </div>
                                        <Button
                                          color="primary"
                                          className="submit"
                                          // onClick={() => handleDeleteTask(index)}
                                          style={{ width: "20%" }}
                                        >
                                          <img src={plusIcons} /> Add
                                        </Button>
                                        {/* <Button color="" className=""></Button> */}
                                      </div>
                                      {tasks.map((task, index) => (
                                        <div
                                          key={index}
                                          className="d-flex justify-content-between gap-2  mb-2"
                                        >
                                          <div
                                            className="plan-card"
                                            onClick={() =>
                                              toggleTaskCompletion(index)
                                            }
                                          >
                                            {task.task}
                                          </div>
                                          <Button
                                            color="primary"
                                            className="submit"
                                            // onClick={() => handleDeleteTask(index)}
                                            style={{ width: "20%" }}
                                          >
                                            <img src={plusIcons} />
                                            Add
                                          </Button>
                                          {/* <Button color="" className=""></Button> */}
                                        </div>
                                      ))}
                                    </div>
                                  </Col>
                                  <Col>
                                    <h2 className="heading-pres">
                                      Active Plans
                                    </h2>
                                    <Row
                                      style={{ borderTop: "1px solid #D3D3D3" }}
                                    >
                                      <div className="d-flex mt-2">
                                        <Col md={9}>
                                          <div className="bg-light active-plan-box">
                                            <div>
                                              <span className="active-plan">
                                                Medicare (Primary)
                                              </span>
                                              <span
                                                style={{
                                                  fontSize: "14px",
                                                  paddingLeft: "2px",
                                                }}
                                              >
                                                BIN:098779. PCN:M...
                                              </span>
                                            </div>
                                            <img src={dubbleArrow} />
                                          </div>
                                        </Col>
                                        <Col md={3}>
                                          <div className="d-flex justify-content-end">
                                            <Button className="back-button">
                                              <img src={eidtPurpleIcon} />
                                            </Button>
                                            <Button color="primary">
                                              <img src={deleteIcon} />
                                            </Button>
                                          </div>
                                        </Col>
                                      </div>
                                      <div className="d-flex mt-2">
                                        <Col md={9}>
                                          <div className="bg-light active-plan-box">
                                            <div>
                                              <span className="active-plan">
                                                State Medicaid (Secondary)
                                              </span>
                                              <span
                                                style={{
                                                  fontSize: "14px",
                                                  paddingLeft: "2px",
                                                }}
                                              >
                                                BIN:098...
                                              </span>
                                            </div>
                                            <img src={dubbleArrow} />
                                          </div>
                                        </Col>
                                        <Col md={3}>
                                          <div className="d-flex justify-content-end">
                                            <Button className="back-button">
                                              <img src={eidtPurpleIcon} />
                                            </Button>
                                            <Button color="primary">
                                              <img src={deleteIcon} />
                                            </Button>
                                          </div>
                                        </Col>
                                      </div>
                                    </Row>
                                  </Col>
                                </Row>
                              </AccordionBody>
                            </AccordionItem>
                          </Accordion>
                        </Formik>
                        <Formik>
                          <Accordion
                            open={openThree}
                            toggle={togglebtnThree}
                            style={{ marginBottom: "50px", marginTop: "5px" }}
                          >
                            <AccordionItem>
                              <AccordionHeader targetId="1">
                                Other Details
                              </AccordionHeader>
                              <AccordionBody accordionId="1">
                                <Row>
                                  <Col sm={12} md={3} className="inc">
                                    <FormGroup className="controls textarea_info search-flex mb-0 ">
                                      <Label className="order-entry-details">
                                        Total Quantity Written
                                      </Label>
                                      <InputGroup>
                                        <Input
                                          type="text"
                                          value={increment.totalQtyWritten}
                                          name="totalQtyWritten"
                                          onChange={handleChangeIncrement}
                                          placeholder="Enter Quantity"
                                        />
                                        <InputGroupText>
                                          <div className="d-flex flex-column">
                                            {" "}
                                            <img
                                              src={upArrow}
                                              onClick={handleIncrement}
                                            />
                                            <img
                                              src={downArrow}
                                              onClick={handleDecrement}
                                            />
                                          </div>
                                        </InputGroupText>
                                      </InputGroup>
                                    </FormGroup>
                                  </Col>
                                  <Col sm={12} md={3}>
                                    <FormGroup className="controls textarea_info search-flex mb-0">
                                      <Label className="order-entry-details">
                                        Diagnosis Code
                                      </Label>
                                      <InputGroup>
                                        <Input
                                          setcss="required"
                                          type="text"
                                          name="dignosis"
                                          value={searchTermPrescriber.dignosis}
                                          onChange={handleInputChangePrescriber}
                                          placeholder="Search by Diagnosis Code "
                                        />

                                        {searchTermPrescriber.dignosis ? (
                                          <button
                                            onClick={() =>
                                              clearSearch("dignosis")
                                            }
                                            className="clearButton"
                                          >
                                            &#x2715;{" "}
                                            {/* Unicode for the "x" symbol */}
                                          </button>
                                        ) : (
                                          <img src={searchGrayIcon} />
                                        )}
                                      </InputGroup>
                                    </FormGroup>
                                  </Col>
                                  <Col
                                    sm={12}
                                    md={3}
                                    className="required-date "
                                  >
                                    <FormGroup className="controls textarea_info search-flex mb-0">
                                      <Label className="order-entry-details">
                                        Do Not Fill Until
                                      </Label>
                                      <InputGroup
                                        onMouseLeave={handleMouseLeave}
                                      >
                                        <DatePicker
                                          id="startDate"
                                          name="startDate"
                                          selected={startDate}
                                          onChange={(startDate) =>
                                            handleStartDate(startDate)
                                          }
                                          onFocus={() =>
                                            handleFocus("StartDate")
                                          }
                                          onBlur={handleBlur}
                                          isClearable
                                          onChangeRaw={handleStartDateRaw}
                                          dateFormat="MM/dd/yyyy"
                                          placeholderText="MM/DD/YYYY"
                                          autoComplete="off"
                                          customInput={
                                            <ReactInputMask
                                              mask="99/99/9999"
                                              value={startDate}
                                            />
                                          }
                                        />
                                        <InputGroupText
                                          onClick={() =>
                                            handleDateClick("startDate")
                                          }
                                        >
                                          <img src={Calendar} alt="" />
                                        </InputGroupText>
                                      </InputGroup>
                                    </FormGroup>
                                  </Col>
                                  <Col sm={12} md={3}>
                                    <Label className="order-entry-details">
                                      Treatment Type
                                    </Label>
                                    <FormGroup className="controls textarea_info search-flex mb-0">
                                      <InputGroup>
                                        <Field
                                          as="select"
                                          name="option"
                                          id="option"
                                          value={setSelectedOptions.option1}
                                          onChange={handleChangeOption}
                                          // className="form-control"
                                        >
                                          <option
                                            value=""
                                            label="Select Type"
                                          />
                                          <option
                                            value="option1"
                                            label="Option 1"
                                          />
                                          <option
                                            value="option2"
                                            label="Option 2"
                                          />
                                          <option
                                            value="option3"
                                            label="Option 3"
                                          />
                                        </Field>
                                      </InputGroup>
                                    </FormGroup>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col sm={12} md={3} className="inc">
                                    <FormGroup className="controls textarea_info search-flex mb-0">
                                      <Label className="order-entry-details">
                                        Serial Number
                                      </Label>
                                      <InputGroup>
                                        <Input
                                          type="text"
                                          // value={increment.serialNo}
                                          name="serialNo"
                                          // onChange={handleChangeIncrement}
                                          placeholder="Enter Serial Number"
                                        />
                                        <InputGroupText>
                                          <div className="d-flex flex-column">
                                            {" "}
                                            {/* <img src={upArrow} onClick={handleIncrement} />
                              <img src={downArrow} onClick={handleDecrement} /> */}
                                          </div>
                                        </InputGroupText>
                                      </InputGroup>
                                    </FormGroup>
                                  </Col>
                                  <Col sm={12} md={3}>
                                    <Label className="order-entry-details">
                                      DAW
                                    </Label>
                                    <FormGroup className="controls textarea_info search-flex mb-0">
                                      <InputGroup>
                                        <Field
                                          as="select"
                                          name="option"
                                          id="option"
                                          className="order-detail-input"
                                          value={setSelectedOptions.option2}
                                          onChange={handleChangeOption}
                                          // className="form-control"
                                        >
                                          <option value="" label="Select DAW" />
                                          <option
                                            value="option1"
                                            label="Option 1"
                                          />
                                          <option
                                            value="option2"
                                            label="Option 2"
                                          />
                                          <option
                                            value="option3"
                                            label="Option 3"
                                          />
                                        </Field>
                                      </InputGroup>
                                    </FormGroup>
                                  </Col>
                                  <Col sm={12} md={3} className="inc">
                                    <FormGroup className="controls textarea_info search-flex mb-0">
                                      <Label className="order-entry-details">
                                        Partial Fill QTY
                                      </Label>
                                      <InputGroup>
                                        <Input
                                          type="text"
                                          value={increment.partialFillQty}
                                          name="partialFillQty"
                                          onChange={handleChangeIncrement}
                                          placeholder="Enter Quantity"
                                        />
                                        <InputGroupText>
                                          <div className="d-flex flex-column">
                                            {" "}
                                            <img
                                              src={upArrow}
                                              onClick={handleIncrement}
                                            />
                                            <img
                                              src={downArrow}
                                              onClick={handleDecrement}
                                            />
                                          </div>
                                        </InputGroupText>
                                      </InputGroup>
                                    </FormGroup>
                                  </Col>
                                  <Col sm={12} md={3}>
                                    <FormGroup className="controls textarea_info search-flex mb-0">
                                      <Label className="order-entry-details">
                                        Partial Fill Days Supply
                                      </Label>
                                      <InputGroup>
                                        <Input
                                          type="text"
                                          value={increment.partialFillDaySupply}
                                          name="partialFillDaySupply"
                                          onChange={handleChangeIncrement}
                                          placeholder="Enter Quantity"
                                        />
                                        <InputGroupText>
                                          <div className="d-flex flex-column">
                                            {" "}
                                            <img
                                              src={upArrow}
                                              onClick={handleIncrement}
                                            />
                                            <img
                                              src={downArrow}
                                              onClick={handleDecrement}
                                            />
                                          </div>
                                        </InputGroupText>
                                      </InputGroup>
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </AccordionBody>
                            </AccordionItem>
                          </Accordion>
                        </Formik>
                      </div>
                    </Row>
                  </div>
                </>
              );
            }}
          ></Formik>
        </Container>

        <Container fluid className="rx-detail-footer">
          <div>
            <Button
              color="primary"
              className="reset "
              disabled={!isButtonEnabled}
              onClick={() => {
                setSearchTermPrescriber({
                  medication: "",
                  prescriber: "",
                  dignosis: "",
                });
                setDirections("");
                setEndDate(null);
                setStartdate(null);
                setIncrement({
                  totalQtyWritten: 0,
                  serialNo: 0,
                  partialFillQty: 0,
                });
                setIsImageVisible(true);
              }}
            >
              <img src={resetIcon} />
              Reset
            </Button>
          </div>
          <div className="d-flex  align-items-end">
            <Button className="back-button " disabled={!isButtonEnabled}>
              <img src={saveIcon} />
              Save
            </Button>

            <Button
              color="primary"
              className="submit "
              onClick={onsubmit}
              disabled={!isButtonEnabled}
            >
              <img src={submitIcon} />
              Submit
            </Button>
          </div>
        </Container>
      </Container>
      <div>
        <Drawer
          direction="end"
          size="lg"
          isOpen={drugUtil}
          toggle={() => setDrugUtil(!drugUtil)}
          title="Drug Utilization Review"
        >
          <DrugUtilPopUp />
        </Drawer>
        <Drawer
          direction="end"
          size="lg"
          isOpen={claimsInfo}
          toggle={() => setClaimsInfo(!claimsInfo)}
          title="Claims Information"
        >
          <ClaimsInfo />
        </Drawer>
        <Drawer
          direction="end"
          size="lg"
          isOpen={msgInfo}
          toggle={() => setMsgInfo(!msgInfo)}
          title="Chat"
        >
          <Chating />
        </Drawer>
      </div>
    </>
  );
};
export default AddNewPatient;
